export const setItemToStorage = (key, value) =>
  typeof sessionStorage !== 'undefined' && sessionStorage.setItem(key, JSON.stringify(value))

export const getItemFromStorage = (key) =>
  typeof sessionStorage !== 'undefined' && JSON.parse(sessionStorage.getItem(key))

export const storageHasItem = (key) => typeof sessionStorage !== 'undefined' && sessionStorage.getItem(key)
